export default function detectDevice() {
    if (typeof window === 'undefined') return 'desktop';
    const userAgent = navigator.userAgent;
    if (/Mobi|Android|Tablet|iPad/i.test(userAgent)) {
        return 'mobile';
    }
    return 'desktop';
}
